var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.588366 16.3134358c-1.0777597 0-1.9512887-.8419229-1.9512887-1.8803048 0-1.0380721.873529-1.879995 1.9512887-1.879995 1.0777598 0 1.9512887.8419229 1.9512887 1.879995 0 1.0383819-.8735289 1.8803048-1.9512887 1.8803048zm-5.5882052 0c-1.0777597 0-1.9512887-.8419229-1.9512887-1.8803048 0-1.0380721.873529-1.879995 1.9512887-1.879995 1.0774381 0 1.9512887.8419229 1.9512887 1.879995 0 1.0383819-.8738506 1.8803048-1.9512887 1.8803048zm-5.5885268 0c-1.07775975 0-1.95128869-.8419229-1.95128869-1.8803048 0-1.0380721.87352894-1.879995 1.95128869-1.879995 1.0777597 0 1.9512887.8419229 1.9512887 1.879995 0 1.0383819-.873529 1.8803048-1.9512887 1.8803048zM27 14.6348578C27 9.31342169 22.0753037 5 16.0001608 5 9.92501791 5 5 9.31342169 5 14.6348578c0 5.3211263 4.92501791 9.6348578 11.0001608 9.6348578.584068 0 1.1536629-.0517486 1.7132874-.128597L22.6313904 27l.435478-4.9861543C25.4700379 20.2463344 27 17.5981661 27 14.6348578z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.d3a4a674374a1f373da0241b88db8ac2.svg";
export { ForwardRef as ReactComponent };